import { h } from 'preact';
import PropTypes from 'prop-types';

import LoginBarContainer from '../../containers/login-bar/login-bar';

export const LoginBarContainerComponent = ({ $root, htmlProps, widget }) => {
  return <LoginBarContainer htmlProps={htmlProps} widget={widget} $root={$root} />;
};

LoginBarContainerComponent.propTypes = {
  htmlProps: PropTypes.object.isRequired,
  $root: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};
